import { render, staticRenderFns } from "./DatingFeedbackPage.vue?vue&type=template&id=57a80dc4&scoped=true"
import script from "./DatingFeedbackPage.vue?vue&type=script&lang=js"
export * from "./DatingFeedbackPage.vue?vue&type=script&lang=js"
import style0 from "./DatingFeedbackPage.vue?vue&type=style&index=0&id=57a80dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a80dc4",
  null
  
)

export default component.exports